import React from 'react'

import { BackendChallengeDetails } from './backend.types'

type BackendChallengeContextProps = {
  question: BackendChallengeDetails
}

const BackendChallengeContext =
  React.createContext<BackendChallengeContextProps | null>(null)

export default BackendChallengeContext
